import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardProps, EntityCardDefaultProps, CellHeader, } from '@shapeable/ui';
import { ImpactStory } from '@shapeable/doing-co-types';

const cls = classNames('impact-story-card');

// -------- Types -------->

// -------- Props -------->

export type ImpactStoryCardProps = EntityCardProps & { 
  entity?: ImpactStory;
};

export const ImpactStoryCardDefaultProps: Omit<ImpactStoryCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  colors: {
    text: 'text',
    hover: {
      text: 'mid',
    }
  }
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const TypeLabelStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('primary')};
  `,
});

const SpaceLabelStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('sub')};
  `,
});

const LocationLabelStyles = breakpoints({
  base: css`
    display: flex;
    ${theme.H_DOT_BG()};
    padding-top: ${theme.UNIT(2)};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    TypeLabel: styled(CellHeader)`${TypeLabelStyles}`,
    SpaceLabel: styled.span`${SpaceLabelStyles}`,
    LocationLabel: styled.span`${LocationLabelStyles}`,
};

export const ImpactStoryCard: Shapeable.FC<ImpactStoryCardProps> = (props) => {
  const { className, children, entity, ...rest } = props;

  const { location, typeLabel, spaces = [] } = entity || {};

  const hasLocation = !!location?.name;
  const hasSpace = spaces.length > 0;

  const space = spaces[0];

  return (
    <My.Container 
      className={cls.name(className)} 
      {...rest}
      showTypeHeader={false}
      pretitle={
        <My.TypeLabel>{typeLabel}</My.TypeLabel>
      }
      entity={entity}
      meta={
        hasSpace && <My.SpaceLabel>{space.name}</My.SpaceLabel>
      }
      foot={
        hasLocation && <My.LocationLabel>{location.name}{!!location?.state && ', '}{location?.state?.abbr || location?.state?.name}</My.LocationLabel>
      }
      />
  )
};

ImpactStoryCard.defaultProps = ImpactStoryCardDefaultProps;
ImpactStoryCard.cls = cls;